import { com } from '@eidu/web'
import EntityId = com.eidu.entity.EntityId
import PermissionPolicy = com.eidu.entity.permission.PermissionPolicy
import PermissionPolicyId = com.eidu.entity.permission.PermissionPolicyId
import entityIdFromString = com.eidu.entity.entityIdFromString
import permissionPolicyIdFromString = com.eidu.entity.permission.permissionPolicyIdFromString

export type PermissionPolicyDTO = {
  policyId: PermissionPolicyId
  organizationId: string
  policy: PermissionPolicy
  createdBy: EntityId
}

const permissionPolicyDTO: ({
  policyId,
  organizationId,
  policy,
  createdBy,
}: {
  policyId: string
  organizationId: string
  policy: unknown
  createdBy: string
}) => PermissionPolicyDTO = ({ policyId, organizationId, policy, createdBy }) => ({
  policyId: permissionPolicyIdFromString(policyId),
  organizationId,
  policy: PermissionPolicy.fromJsonString(JSON.stringify(policy)),
  createdBy: entityIdFromString(createdBy),
})

export default permissionPolicyDTO
